import React, { useState, useEffect, useRef } from 'react';
import { IonIcon, IonButton, IonLabel, IonItem, IonReorder, IonReorderGroup, IonSearchbar, IonSelect, IonSelectOption, IonList, IonModal, IonContent, IonInput, IonHeader, IonToolbar, IonButtons, IonTitle, IonTextarea, IonAvatar, IonImg } from '@ionic/react';
import { remove } from 'ionicons/icons';
import prefs, { Role } from '@/controllers/preferences';
import NewRole from './RoleSelector/NewRole';

interface RoleSelector {
  id: string;
  name: string;
  enabled: boolean;
}

const predefinedRoles = Object.keys(prefs.model_roles)

const defaultRoles: Role[] = [
  'Narrator',
  'User',
  'Teacher',
  'User',
  'Teacher',
  'User',
  'Skeptic',
  'User'
]

const RoleSelector: React.FC = () => {
  const [roles, setRoles] = useState<RoleSelector[]>([]);
  const [removeMode, setRemoveMode] = useState<boolean>(false);

  // Initialize roles from preferences or set defaults
  useEffect(() => {
    const loadRoles = async () => {
      let savedRoles = await prefs.get('conversationRoles');
      if (!savedRoles || savedRoles.length === 0) {
        savedRoles = defaultRoles.map((role, index) => ({
          id: `${index}-${role}`,
          name: role,
          enabled: true
        }));
      }
      setRoles(savedRoles);
    };
    loadRoles();
  }, []);

  // Save roles to preferences whenever they change
  useEffect(() => {
    if (roles.length > 0) {
      prefs.set('conversationRoles', roles);
    }
  }, [roles]);

  

  // Add a new role
  // const addRole = () => {
  //   if (newRoleName.trim() !== '') {
  //     const newRole: Role = {
  //       id: `${Date.now()}-${newRoleName}`,
  //       name: newRoleName,
  //       enabled: true
  //     };
  //     setRoles([...roles, newRole]);
  //     setNewRoleName('');
  //   }
  // };

  // Add a role directly from a suggestion (bypasses the need to press the add button)
  const addSuggestedRole = (role: string) => {
    const newRole: RoleSelector = {
      id: `${Date.now()}-${role}`,
      name: role,
      enabled: true
    };
    setRoles([...roles, newRole]);
    //setNewRoleName('');
  };

  // Remove a role
  const removeRole = (id: string) => {
    setRoles(roles.filter(role => role.id !== id));
  };

  // Handle reorder event
  const handleReorder = (event: CustomEvent) => {
    const newRoles = [...roles];
    const item = newRoles.splice(event.detail.from, 1)[0];
    newRoles.splice(event.detail.to, 0, item);
    setRoles(newRoles);
    event.detail.complete();
  };

  const resetRoles = () => {
    const defaultRoles1 = defaultRoles.map((role, index) => ({
      id: `${index}-${role}`,
      name: role,
      enabled: true
    }));
    setRoles(defaultRoles1);
    // Persist the reset roles to preferences
    prefs.set('conversationRoles', defaultRoles1);
  };

  const [newRoleModalOpen, setNewRoleModalOpen] = useState(false)

  // TODO: Add "Conversation presets" with preset role orders
  return (
    <div className="p-4 bg-white dark:bg-gray-800">
      <IonLabel className="text-lg font-semibold text-gray-700 dark:text-gray-200 mb-4 block text-center">
        Conversation Flow
      </IonLabel>
      <IonReorderGroup onIonReorderEnd={handleReorder} disabled={false}>
        {roles.map((role) => (
          <IonItem key={role.id} className="mb-2 rounded-lg border border-gray-200 dark:border-gray-600">
            <div slot="start">
              <IonReorder slot="start"></IonReorder>
            </div>
            <div>
              {/* Role name */}
              <div className={`flex-1 font-medium ${role.enabled ? 'text-gray-800 dark:text-gray-200' : 'text-gray-400 dark:text-gray-500'}`}>
                {role.name}
              </div>
              
              
            </div>
            <div slot="end">
              {/* Toggle button */}
              {removeMode && (roles.filter((r) => r.name === 'User').length > 1 || role.name !== 'User') && (
                <IonButton 
                  fill="clear" 
                  color="danger"
                  onClick={() => removeRole(role.id)}
                >
                  <IonIcon icon={remove} />
                </IonButton>
              )}
            </div>
          </IonItem>
        ))}
      </IonReorderGroup>

      <div className='flex'>
        <IonButton onClick={resetRoles} color="danger">
          Reset
        </IonButton>
        <IonButton onClick={() => setRemoveMode(!removeMode)} color={removeMode ? "success" : "medium"}>
          {removeMode ? "Finish Remove" : "Remove Roles"}
        </IonButton>
        <IonButton onClick={() => setNewRoleModalOpen(true)}>
          Add roles
        </IonButton>
      </div>

      <NewRole
        open={newRoleModalOpen}
        onClose={() => { console.log("close"); setNewRoleModalOpen(false) }}
        onAddRole={addSuggestedRole}
        predefinedRoles={predefinedRoles}
      />
    </div>
  );
};

export default RoleSelector;
